export default {
    //get all ASSISTANTS
    GET_ALL_ASSISTANTS_REQUEST: 'GET_ALL_ASSISTANTS_REQUEST',
    GET_ALL_ASSISTANTS_SUCCESS: 'GET_ALL_ASSISTANTS_SUCCESS',
    GET_ALL_ASSISTANTS_FAIL: 'GET_ALL_ASSISTANTS_FAIL',

    //edit ASSISTANT
    EDIT_ASSISTANT_REQUEST: 'EDIT_ASSISTANT_REQUEST',
    EDIT_ASSISTANT_SUCCESS: 'EDIT_ASSISTANT_SUCCESS',
    EDIT_ASSISTANT_FAIL: 'EDIT_ASSISTANT_FAIL',

    //create ASSISTANT
    CREATE_ASSISTANT_REQUEST: 'CREATE_ASSISTANT_REQUEST',
    CREATE_ASSISTANT_SUCCESS: 'CREATE_ASSISTANT_SUCCESS',
    CREATE_ASSISTANT_FAIL: 'CREATE_ASSISTANT_FAIL',

    DELETE_ASSISTANT_REQUEST: 'DELETE_ASSISTANT_REQUEST',
    DELETE_ASSISTANT_SUCCESS: 'DELETE_ASSISTANT_SUCCESS',
    DELETE_ASSISTANT_FAIL: 'DELETE_ASSISTANT_FAIL',

    SUSPEND_ASSISTANT_REQUEST: 'SUSPEND_ASSISTANT_REQUEST',
    SUSPEND_ASSISTANT_SUCCESS: 'SUSPEND_ASSISTANT_SUCCESS',
    SUSPEND_ASSISTANT_FAIL: 'SUSPEND_ASSISTANT_FAIL',

    //loading
    ADD_ASSISTANTS_LOADING: 'ADD_ASSISTANTS_LOADING'
};

